import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import "./Button.scss";

interface Props {
	is? : any,
	color : 'brand' | 'light' | 'dark' | 'red-transparent' | 'brand-transparent'
	size? : 'big' | 'normal' | 'small'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    is: { default: 'button' },
    color: {},
    size: { default: 'normal' }
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(props).is), {
    class: _normalizeClass(["btn", `btn--${_ctx.color} btn--${_ctx.size}`])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})